import { Input } from "@headlessui/react";
import {
	PeerReviewCustomQuestionSettingViewModel,
	PeerReviewQuestionSettingViewModel,
} from "../prompts/promptsApiSlice";

interface Props {
	title: string;
	generalQuestions: PeerReviewQuestionSettingViewModel[];
	reviewQuestions: PeerReviewQuestionSettingViewModel[];
	customQuestions: PeerReviewCustomQuestionSettingViewModel[];
}

export default function PrintPeerReviewDocument(props: Props) {
	const reviewQuestions = props.reviewQuestions.map((q) => {
		return { question: q.question, isEnabled: q.isEnabled };
	});
	const otherQuestions = reviewQuestions.concat(props.customQuestions);

	const textClasses = "p-2 text-sm";
	const borderClasses = "border border-solid border-black";
	const getPageMargins = () => {
		return `@page { margin: 40px 50px 40px 50px !important; }`;
	};

	return (
		<div>
			<style>{getPageMargins()}</style>
			<h1>Peer Review: {props.title}</h1>
			<table className="mt-3 w-full">
				<thead>
					<HeaderRow isGeneral={true} />
				</thead>
				<tbody>
					{props.generalQuestions?.map((row, index) => (
						<tr key={`general-${index}`}>
							<td className={`${textClasses} ${borderClasses} h-20`}>
								{row.question}
							</td>
							<td className={`${borderClasses} h-20`}></td>
						</tr>
					))}
				</tbody>
			</table>
			{otherQuestions.length > 0 && (
				<table className="w-full">
					<thead>
						<HeaderRow isGeneral={false} />
					</thead>
					<tbody>
						{otherQuestions.map((row, index) => (
							<tr key={`other-${index}`}>
								<td className={`${textClasses} ${borderClasses} h-24`}>
									{row?.question}
								</td>
								<td className={`${borderClasses} h-24`}>
									<div className="px-4 flex justify-between">
										<Input type="checkbox" />
										<Input type="checkbox" />
										<Input type="checkbox" />
									</div>
								</td>
								<td className={`${borderClasses} h-24`}></td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	);
}

interface HeaderRowProps {
	isGeneral: boolean;
	className?: string;
}

function HeaderRow({ isGeneral, className }: HeaderRowProps) {
	const commonClasses = "text-sm p-1 border border-solid border-black !bg-primary-800/10";
	return (
		<tr>
			<th className={`${className} ${commonClasses} w-[25%]`}>Review Question</th>
			{!isGeneral && (
				<th className={`${className} ${commonClasses} text-center w-[25%]`}>
					Yes / Somewhat / No
				</th>
			)}
			<th className={`${className} ${commonClasses} min-w-1/2`}>Comment</th>
		</tr>
	);
}
